import { movies } from "@/mocks/movies";
import type { Movie } from "@/types/movie";
import { filterMovies } from "@/lib/movieList";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import LatestUpdates from "@/pages/home/components/LatestUpdates";
import HotRail from "@/pages/home/components/HotRail";
import SectionHeader from "@/components/feature/SectionHeader";
import MovieCard from "@/components/feature/MovieCard";

const list = movies as Movie[];

export default function Home() {
  const latestMovies = filterMovies(list, { category: "movie", sort: "year" });
  const latestTv = filterMovies(list, { category: "tv", sort: "year" });
  const hotRail = filterMovies(list, { sort: "heat" }).slice(0, 8);
  const topRated = filterMovies(list, { sort: "rating" }).slice(0, 6);

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestUpdates movies={latestMovies} tvShows={latestTv} />
      <HotRail movies={hotRail} />

      <section className="mx-auto w-full max-w-[1440px] px-4 pt-12 md:px-8 md:pt-16">
        <SectionHeader title="口碑榜" subtitle="评分领先 · 高分佳作精选" moreTo="/category" />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 md:gap-5">
          {topRated.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </section>
    </div>
  );
}